const apiArr = [
  // {
  //   name: "test", // 接口调用方法名
  //   path: '/api/test', // 后端路径
  //   method: "POST", // 默认POST
  //   headers: {"token": 123}, // 自定义单个接口的请求头
  //   desc: "登录接口", // 接口描述
  // }
  {
    name: "checklogin",
    path: "/pcclient/checklogin",
    desc: "检查是否登录"
  },
  {
    name: "smscodelogin",
    path: "/pcclient/smscodelogin",
    desc: "手机号+验证码登录"
  },
  {
    name: "getrecommentcourselist",
    path: "/pccourse/getrecommentcourselist",
    // method: "GET",
    desc: "推荐课程"
  },
  {
    name: "getcoursedetail",
    path: "/pccourse/getcoursedetail",
    desc: "课程详情"
  },
  {
    name: "getcoursecontentinfo",
    path: "/pccourse/getcoursecontentinfo",
    desc: "播放详情"
  },
  {
    name: "getcoursechapterlist",
    path: "/pccourse/getcoursechapterlist",
    desc: "课程目录"
  },
  {
    name: "getusercourselist",
    path: "/pccourse/getusercourselist",
    desc: "学习中心"
  },
  {
    name: "getvidplayauth",
    path: "/pcclient/getvidplayauth223",
    method: "GET",
    desc: "播放授权"
  },
  {
    name: "getselfinfo",
    path: "/pcclient/getselfinfo",
    method: "GET",
    desc: "个人详情"
  },
  {
    name: "getpcbdvideolist",
    path: "/pcbdvideo/getlist",
    method: "GET",
    desc: "影音库全部列表"
  },
  {
    name: "getpcbdvideohistory",
    path: "/pcbdvideo/gethistory",
    method: "GET",
    desc: "影音库观看历史"
  },
  {
    name: "getpcbdvideocheckisvip",
    path: "/pcbdvideo/checkisvip",
    method: "GET",
    desc: "影音库检查vip"
  },
  {
    name: "getpcbdvideoclearhistory",
    path: "/pcbdvideo/clearhistory",
    method: "GET",
    desc: "影音库清空历史"
  },

  {
    name: "getpcbdvideoclearhistory",
    path: "/pcbdvideo/clearhistory",
    desc: "影音库清空历史"
  },
  {
    name: "freebuy",
    path: "/pccourse/freebuy",
    desc: "免费加入学习中心"
  },
  {
    name: "getsmscode",
    path: "/pcclient/getsmscode",
    desc: "短信验证码"
  },
  {
    name: "downapp",
    path: "/downapp/downloadauth",
    desc: "下载APP授权"
  },
    {
    name: "getandroidappurl",
    path: "/downapp/getandroidappurl",
    desc: "获取安卓App下载地址"
  }
];

export default apiArr;



// WEBPACK FOOTER //
// ./src/request/api.js